/**
 * What a player reads when the 3D table cannot be built or the page stops: a sentence they can
 * act on where one is known, the reason given otherwise (client-audio-engine:quality#1).
 */
export function failureReason(error: unknown): string {
  const message =
    error instanceof Error ? error.message : typeof error === 'string' ? error : undefined;
  if (message && /webgl (is )?not supported|webgl.*unavailable/i.test(message))
    return (
      'This browser cannot draw 3D graphics: WebGL is turned off or not available here. ' +
      'Turn on hardware acceleration in its settings, or play in Chrome, Edge or the Quest browser.'
    );
  return message ? `The reason given: ${message}` : 'No reason was given.';
}
